import { render } from "./RadarChart.vue?vue&type=template&id=4f6a0bad"
import script from "./RadarChart.vue?vue&type=script&lang=js"
export * from "./RadarChart.vue?vue&type=script&lang=js"
script.render = render

export default script